import { useState } from 'react';
import { FeedbackList } from './pages/FeedbackList';
import { FeedbackDetail } from './pages/FeedbackDetail';
import { ProjectsPage } from './pages/ProjectsPage';

type View = 'feedback' | 'projects';

function App() {
  const [view, setView] = useState<View>('feedback');
  const [selectedFeedbackId, setSelectedFeedbackId] = useState<string | null>(null);

  const goToView = (next: View) => {
    setSelectedFeedbackId(null);
    setView(next);
  };

  return (
    <div className="min-h-screen bg-dark-900">
      <header className="bg-dark-800 border-b border-dark-700 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-dark-100">🐛 FeedbackKit Dashboard</h1>
          <nav className="flex gap-2">
            <button
              onClick={() => goToView('feedback')}
              className={view === 'feedback' ? 'btn-primary text-xs' : 'btn-secondary text-xs'}
            >
              Feedback
            </button>
            <button
              onClick={() => goToView('projects')}
              className={view === 'projects' ? 'btn-primary text-xs' : 'btn-secondary text-xs'}
            >
              Projects
            </button>
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {view === 'projects' ? (
          <ProjectsPage />
        ) : selectedFeedbackId ? (
          <FeedbackDetail
            feedbackId={selectedFeedbackId}
            onBack={() => setSelectedFeedbackId(null)}
          />
        ) : (
          <FeedbackList onSelectFeedback={setSelectedFeedbackId} />
        )}
      </main>
    </div>
  );
}

export default App;
